"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CellInput = void 0;
var React = __importStar(require("react"));
var react_1 = require("react");
var styles = __importStar(require("./CellInput.module.css"));
var CellInput = (function (_super) {
    __extends(CellInput, _super);
    function CellInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CellInput.prototype.handleChange = function (evt) {
        this.value = evt.target.validity.valid ? evt.target.value : this.value;
    };
    CellInput.prototype.render = function () {
        var _a = this.props, onChangeTable = _a.onChangeTable, type = _a.type, placeholder = _a.placeholder, disabled = _a.disabled, errors = _a.errors, pattern = _a.pattern, classNameWrap = _a.classNameWrap, className = _a.className, children = _a.children, data = _a.data, row = _a.row, keyCol = _a.keyCol, tableType = _a.tableType, id = _a.id;
        this.value = data || "";
        var error = errors[data];
        var css = "".concat(styles.root, " ").concat(className);
        if (error) {
            css = "".concat(css, " ").concat(styles.rootError);
        }
        return (React.createElement("div", { className: classNameWrap },
            React.createElement("input", { className: css, onChange: function (event) {
                    onChangeTable(row, keyCol, event.target.value, tableType, id);
                }, type: type, placeholder: placeholder, readOnly: true, onInput: this.handleChange.bind(this), value: this.value, pattern: pattern }),
            children,
            error && React.createElement("p", { className: styles.error },
                error,
                " ")));
    };
    CellInput.defaultProps = {
        type: "text",
        errors: {}
    };
    return CellInput;
}(react_1.Component));
exports.CellInput = CellInput;
//# sourceMappingURL=data:application/json;base64,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